import { Pipe, PipeTransform } from '@angular/core';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'diffBetweenDates'
})
export class DiffBetweenDates implements PipeTransform {

  dayAgoString: string;
  daysAgoString: string;
  moreThanString: string;
  today: string;

  constructor(private translate: TranslateService) { }

  transform(value: string): string {
    this.translate.get(['CAREER_MORE_THAN', 'CAREER_DAYS_AGO', 'CAREER_DAY_AGO', 'CAREER_TODAY']).subscribe((obj) => {
      this.daysAgoString = obj.CAREER_DAYS_AGO;
      this.moreThanString = obj.CAREER_MORE_THAN;
      this.dayAgoString = obj.CAREER_DAY_AGO;
      this.today = obj.CAREER_TODAY;
    });
    const postedDate: any = new Date(value);
    const today: any = new Date();

    const timeDiff = Math.abs(today.getTime() - postedDate.getTime());
    const diffDays = timeDiff / (1000 * 3600 * 24);
    const roundedDiffDays = Math.floor(diffDays);

    let diffDaysString;

    if (roundedDiffDays === 1) {
      diffDaysString = roundedDiffDays + ' ' + this.dayAgoString;
    } else if (roundedDiffDays === 0) {
      diffDaysString = this.today;
    } else if (roundedDiffDays < 30) {
      diffDaysString = roundedDiffDays + ' ' + this.daysAgoString;
    } else {
      diffDaysString = this.moreThanString + ' ' + 30 + ' ' + this.daysAgoString;
    }

    return diffDaysString;
  }
}



// WEBPACK FOOTER //
// ../UI/src/app/shared/pipes/dates-diff.pipe.ts